import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'product-stock',
  imports: [NgClass, TranslateModule],
  templateUrl: './product-stock.component.html',
  styleUrl: './product-stock.component.scss',
})
export class ProductStockComponent {
  @Input({ required: true }) has!: boolean;
  @Input() labelable: boolean = false;
}
